import { Accordion } from "@wise-emotions/react-accordion";
import { CfAccordionProps } from "../../types";
import { convertCfAccordionItemProps } from "components/Accordion/AccordionItem/CfAccordionItem";
import AccordionGroup, { AccordionGroupProps } from "..";
import React from "react";

export const convertCfAccordionGroupProps = ({
  children,
}: CfAccordionProps) => {
  const props: AccordionGroupProps = {
    children: children.map((accordionItem) => (
      <Accordion
        variant="default"
        {...convertCfAccordionItemProps(accordionItem.props)}
      />
    )),
  };
  return props;
};

const CfAccordionGroup = (props: CfAccordionProps) => {
  return <AccordionGroup {...convertCfAccordionGroupProps(props)} />;
};

export default CfAccordionGroup;
